import { Navigate, Outlet, Route } from 'react-router-dom';

import AdminLayout from '@app/layout/admin';
import AdminBalancePage from '@app/pages/admin/AdminBalancePage';
import AdminWithdrawalsPage from '@app/pages/admin/AdminWithdrawalsPage';
import AdminWithdrawalDetailsPage from '@app/pages/admin/AdminWithdrawalDetailsPage';
import AdminUsersPage from '@app/pages/admin/AdminUsersPage';
import AdminUserDetailsPage from '@app/pages/admin/AdminUserDetailsPage';
import AdminMatrixChannelFormPage from '@app/pages/admin/AdminMatrixChannelFormPage';
import { useGetCurrentUserQuery } from '@app/store/slices/users/usersApi';
import { UserRole } from '@app/store/slices/users/usersTypes';
import { Page } from './';
import { LoadingSpinner } from '@app/shared/ui/atoms/Common';

function AdminGuard() {
  const { data: user, isLoading: isUserLoading } = useGetCurrentUserQuery();

  if (isUserLoading) {
    return <LoadingSpinner />;
  }

  if (user?.role !== UserRole.SUPER) {
    return <Navigate to={Page.HOME} replace />;
  }

  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}

export const AdminRoutes = (
  <Route element={<AdminGuard />}>
    <Route path={Page.ADMIN_HOME} element={<>Welcome to Admin Panel</>} />
    <Route path={Page.ADMIN_BALANCE} element={<AdminBalancePage />} />
    <Route path={Page.ADMIN_WITHDRAWALS} element={<AdminWithdrawalsPage />} />
    <Route path={Page.ADMIN_WITHDRAWAL_DETAILS} element={<AdminWithdrawalDetailsPage />} />
    <Route path={Page.ADMIN_USERS} element={<AdminUsersPage />} />
    <Route path={Page.ADMIN_USER_DETAILS} element={<AdminUserDetailsPage />} />
    <Route path={Page.ADMIN_MATRIX_CHANNEL_FORM} element={<AdminMatrixChannelFormPage />} />
  </Route>
);
